import React, { Component } from 'react';
import withStyles from 'isomorphic-style-loader/lib/withStyles';
import s from './styles.css';
import { Well } from 'react-bootstrap';
import GrayPanel from '../../components/GrayPanel/GrayPanel';
import ModalAlert from '../../routes/eservices/ModalAlert';
import { getTokenFromCookie } from '../../components/utils/utils';
import waiting from '../eserviceSummary/waiting-wheel-300x300.gif';


const loadingTitle = 'Proszę czekać...';

const loadingBody =
  (<div style={{ height: '100px' }}>
    <div style={{ textAlign: 'center' }}>
      <img alt="Loader" src={waiting} style={{ width: '150px', height: '150px' }} />
    </div>
    <p style={{ textAlign: 'center' }}>
      Przetwarzanie danych, proszę czekać...
    </p>
  </div>);

class DeleteAccount extends Component {
  constructor(props) {
    super(props);

    this.state = {
      zgoda: false,
      user: this.props.userData,

      errorTitle: '',
      errorText: '',
      showError: false,
      showResend: false,
      loading: false,
    };
  }

  onHide = () => this.setState({ showError: false });

  changeInput = e => {
    const value = e.target.checked;

    this.setState({
      zgoda: !this.state.zgoda,
    });
  };

sendDeletionEmail = async (resend = false) => {

    const payload = {
      userId: this.state.user.ID,
      resend: resend,
    };

    const FETCH_ERROR = {
      errorText: 'Wystąpił błąd po stronie serwera. Administrator portalu został poinformowany o zaistniałej sytuacji.',
      errorTitle: 'Błąd po stronie serwera.',
      showError: true,
      showResend: false,
      loading: false,
    };
    
    const url = `${process.env.API_URL}/user/send_deletion_email`;
    const token = getTokenFromCookie();

    try {
      const response = await fetch(url, {
        method: 'POST',
        body: JSON.stringify(payload),
        headers: {
          Accept: 'application/json',
          'Content-Type': 'application/json',
          Authorization: `Bearer ${token}`,
        },
      });

      const result = await response.json();

      if (response.status === 200) {
        this.setState({
          errorText: `E-mail z linkiem do usunięcia konta został wysłany na adres ${this.state.user.Email}`,
          errorTitle: 'Wysłano link do usunięcia konta.',
          showError: true,
          showResend: false,
          loading: false,
        });
      } else if (response.status === 409) {
        this.setState({
          errorText: 'Istnieje już aktywny link do usunięcia konta. Sprawdź swoją skrzynkę e-mail lub spróbuj ponownie później.',
          errorTitle: 'Link już wysłany.',
          showError: true,
          showResend: true,
          loading: false,
        });
      } else if (response.status === 400 && result && result.code === 'USER_EMAIL_NOT_FOUND') {
        this.setState({
          errorText: 'Nie można znaleźć adresu e-mail powiązanego z tym kontem. Uzupełnij dane w swoim profilu.',
          errorTitle: 'Błąd wysyłania wiadomości.',
          showError: true,
          showResend: false,
          loading: false,
        });
      } else {
        this.setState(FETCH_ERROR);
      }
    } catch (err) {
      this.setState(FETCH_ERROR);
    }
  };

  render() {
    return (
      <div>
        <div className={s.delContainer} style={{ display: 'block' }}>
          <div className={s.delTitle}>Usuwanie konta</div>
          <GrayPanel title="Informacja">
            <p>Aby usunąć konto zaznacz opcję "Chcę usunąć konto"</p>
            <p> Następnie naciścnij przycisk <b>Usuń konto</b></p>
          </GrayPanel>

          <GrayPanel title="Usuwanie konta">
            <div className="row">
              <input
                type="checkbox"
                className="form-check-input"
                id="checkbox-usuwanie-konta"
                onChange={this.changeInput}
              />
              <label htmlFor="checkbox-usuwanie-konta" style={{ marginLeft: '5px' }}>
                Chcę usunąć konto
              </label>
            </div>
            <div className={`row ${s.containerRow}`}>
              <button
                className="btn btn-danger"
                onClick={() => this.setState({ loading: true } , () => this.sendDeletionEmail())}
                disabled={!this.state.zgoda}
              >
                Usuń konto
              </button>
            </div>
            {this.state.showResend &&
              <div className={`row ${s.resendRow}`}>
                <p className={s.resendText}>E-mail nie dotarł?</p>
                <a
                  className={s.resendButton}
                  onClick={() => this.setState({ loading: true } , () => this.sendDeletionEmail(true))}
                  disabled={!this.state.showResend}
                >
                  Wyślij ponownie
                </a>
              </div>
            }
            
          </GrayPanel>
        </div>
        <ModalAlert
          title={this.state.errorTitle}
          bodyText={this.state.errorText}
          show={this.state.showError}
          name="errorModal"
          onHide={this.onHide}
        />

        <ModalAlert
          title={loadingTitle}
          bodyText={loadingBody}
          show={this.state.loading}
          name="loadingModal"
          onHide={this.onHide}
          disableButton
        />
      </div>
    );
  }
}

export default withStyles(s)(DeleteAccount);



// WEBPACK FOOTER //
// src/routes/DeleteAccount/index.js